import { Button, Icon } from '@ps/isp-web-component-library';
import { Finishingpost } from '@ps/isp-web-component-library/icons/Finishingpost';
import { Translation } from '@ps/web-shared-components';
import replace from 'lodash/replace';
import trim from 'lodash/trim';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { SportsLink } from '@swf/sports/components';
import { isMeetingBasedEventTypeId } from '@swf/sports/utils/isEventTypeId';

import {
  TXTWCL_Return_To_N0,
  TXTWCL_You_have_reached_the_Finishing_ELL_1
} from './MeetingFinishedMessage.messages.json';
import styles from './MeetingFinishedMessage.scss';

const MeetingFinishedMessage: React.FC = () => {
  const { eventTypeSlug, eventTypeId } = useSelector(select.sports.getUrlParams);
  const parsedEventTypeId = Number(eventTypeId);

  if (!isMeetingBasedEventTypeId(parsedEventTypeId)) return null;

  return (
    <div className={styles.container}>
      <Icon icon={Finishingpost} size="xxl" className={styles.finishingPost} />
      <span className={styles.finishedText}>
        <Translation {...TXTWCL_You_have_reached_the_Finishing_ELL_1} />
      </span>
      <Button
        as={SportsLink}
        values={{ eventTypeSlug, eventTypeId }}
        alias="sportsAnimalRacingNext"
      >
        <Translation
          values={{ 0: trim(replace(eventTypeSlug, /-/g, ' ')) }}
          {...TXTWCL_Return_To_N0}
        />
      </Button>
    </div>
  );
};

export default MeetingFinishedMessage;
